module.exports={
	"fields": {
		"research": {
			"title": "research or not?",
			"items": {
				"fields":{
		"locations": {
			"title": "locations",
			"items": {
				"fields": {
					 "hemisphere": {
						"title": "hemisphere",
						"values": [
						    "north",
							"south"
						]
					}
              }
			}
		}
	}
}
}
}
}
